import { render, staticRenderFns } from "./PageShell.vue?vue&type=template&id=17d60a38&scoped=true"
import script from "./PageShell.vue?vue&type=script&lang=js"
export * from "./PageShell.vue?vue&type=script&lang=js"
import style0 from "./PageShell.vue?vue&type=style&index=0&id=17d60a38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d60a38",
  null
  
)

export default component.exports